/**
 * Location detail page (sections/location-page.liquid): FAQ accordion.
 * Driven by the aria attributes already in the markup -- see
 * assets/location-page.css for the show/hide rules. Same behavior as the
 * accordion on the artist directory page, but standalone (the copy in
 * artist-aggregate.js only runs when the directory filters are present).
 */
(function () {
  document.querySelectorAll('.pm-location-faq .pm-accordion-heading').forEach(function (heading) {
    var content = heading.nextElementSibling;

    function toggle() {
      var isOpen = heading.getAttribute('aria-expanded') === 'true';
      heading.setAttribute('aria-expanded', String(!isOpen));
      if (content) content.setAttribute('aria-hidden', String(isOpen));
    }

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
})();
